import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import Recorder from '../../components/recorder/Recorder';
import './cameraRecord.css';
import { setImage, setShowError, setErrorType, setMessageModalVisibility } from "../../redux/actionCreators";
import { connect } from "react-redux";
import config from '../../config/config';
import MainButton from '../../components/buttons/main_button/MainButton';
import TitleComponent from '../../components/title/TitleComponent';
import MessageModal from '../../components/message_modal/MessageModal';


class CameraRecord extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
        };

        this.setRecorderError = this.setRecorderError.bind(this);
    }

    setRecorderError(value) {
        console.log(value);
        this.setState({
            error: value,
        })
    }

    render() {
        if(this.state.error || (/true/i).test(config.force_show_camera_next_button)){
            this.props.setMessageModalVisibility(true)
        }
        return (
            <div className={'camera-record'}>
                <Grid>
                    <Row>
                        <Col xs={12}>
                            <TitleComponent subtitle bold className={'instruction-text text-center'}>Por favor realiza un video indicando lo siguiente:</TitleComponent>
                            <p className={'instruction-text text-center'}>{this.props.stepInfo.information}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <Recorder
                                setImage={this.props.setImage}
                                nextStep={this.props.nextStep}
                                setError={this.setRecorderError}
                            />
                        </Col>
                    </Row>
                </Grid>
                <MessageModal
                    title={'No se ha podido grabar el video'}
                    principalMessage={'Ha ocurrido un error al grabar el video, pero no te preocupes puedes continuar con el proceso'}
                    type={'error'}
                    buttons={
                        <MainButton
                            onClick={this.props.nextStep}
                        />
                    }
                />
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        image: state.image,
        showError: state.showError,
        setErrorType: state.setErrorType,
        stepInfo: state.stepInfo
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setImage(image) {
            dispatch(setImage(image));
        },
        setShowError(showError) {
            dispatch(setShowError(showError));
        },
        setErrorType(errorType) {
            dispatch(setErrorType(errorType));
        },
        setMessageModalVisibility(messageModalVisibility) {
            dispatch(setMessageModalVisibility(messageModalVisibility));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CameraRecord);
